import Rx from 'rxjs/Rx';
import Vue from 'vue';
import VueResource from 'vue-resource';
import VueRx from 'vue-rx';
import store from '../store';
import { DISABLE_LOADING, ENABLE_LOADING } from '../store/types';

Vue.use(VueRx, Rx);
Vue.use(VueResource);

const RequestInterceptor = (req, next) => {
    // modify request
    req.headers.set('Access-Control-Allow-Origin', '*');
   
    if (sessionStorage.token) {
        req.headers.set('Authorization', `Bearer ${sessionStorage.token}`);
    }
    // enable loading
    store.dispatch(ENABLE_LOADING);
    // continue to next interceptor
    next((res) => {
        // disable loading
        store.dispatch(DISABLE_LOADING);
        return res;
    });
};

Vue.http.interceptors.push(RequestInterceptor);



// WEBPACK FOOTER //
// ./src/services/index.js